<div class="upi-wrapper" [class.bg-white]="paymentUtil.utmProceedClicked">
  <!-- Qr Code and UPI Icons -->
  <div class="qr-warpper" *ngIf="!isMobile && option?.vpa_collect_enabled">
    <div class="heading">Scan the QR code from the app and make payment</div>
    <div class="upi-qr">
      <img loading="lazy" [hidden]="!qrURL" [src]="'data:image/png;base64,'+qrURL" alt="qr code">
      <div *ngIf="!qrURL" class="linear-background"></div>
    </div>
    <div class="cards">
      <div class="card-section text-center upi-links">
        <div *ngFor="let key of getObjectKeys(option?.TOPUPI)" class="all-bank submit-payment mt-1">
          <span class="{{key.toUpperCase()}}" matRipple data-bg="/assets/images/payment-modes.png?w=auto"></span>
          <span class="b-name">{{option?.TOPUPI[key]}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="qr-warp" *ngIf="!isMobile && !option?.vpa_collect_enabled">
    <div class="title">Scan QR to pay using any UPI app</div>
    <div class="icons">
      <img *ngFor="let item of staticIcons" class="icon" loading="lazy" src="assets/images/payment/static-icons/{{item}}.png" alt="{{item}}">
      <div class="text">and more...</div></div>
    <div class="qr-scanner">
      <img loading="lazy" [hidden]="!qrURL" [src]="'data:image/png;base64,'+qrURL" alt="qr code">
      <div *ngIf="!qrURL" class="linear-background"></div>
    </div>
    <div class="amount-info">Contribute <app-currency-icon *ngIf="cartDetails?.currency" [currency]="cartDetails?.currency"></app-currency-icon>{{cartDetails?.donated_amount}}</div>
  </div>

  <!-- Clickable UPI Icons for mobile -->
  <div *ngIf="isMobile && !vars.disableUpi" class="cards">
    <div class="heading">
      <h2>{{option?.vpa_collect_enabled ? 'SELECT A UPI APP' : 'Select Payment Method'}}</h2>
    </div>
    <div class="card-section text-center upi-links" *ngIf="option?.vpa_collect_enabled">
      <div *ngFor="let key of getObjectKeys(option?.UPI)" [hidden]="key.match('DESKTOPQR|VPA') || (util.getMobileOperatingSystem() === 'iOS' && !iosSupportedIntent.includes(key))" (click)="vars.upiTimer?$event.stopPropagation():submitOrderMobile('UPI', key)" [style.opacity]="vars.upiTimer?'0.5':'1'" class="all-bank submit-payment mt-1 upi-icons">
        <span class="{{key.toUpperCase()}}" matRipple data-bg="/assets/images/payment-modes.png"></span>
        <span class="b-name">{{option?.UPI[key]}}</span>
      </div>
    </div>
    
    <!-- new upi design here  -->
    <div class="upi-list" *ngIf="!option?.vpa_collect_enabled">
      <ng-container *ngFor="let key of upiOptions; let index = index"> 
        <div class="upi-item" [class.active]="selectedApp === key" (click)="selectAppForPayment(key)">
          <div class="upi-left">
            <img src="{{vars.upiImages[key]}}" [alt]="key"/>
            <span class="upi-name">{{ key }}</span>
          </div>
          <div class="upi-radio">
            <div class="cricle" *ngIf="selectedApp === key"></div>
          </div>
        </div>
        <app-donate-btn *ngIf="selectedApp===key" (click)="submitOrderMobile('UPI', key)" label="Pay" [amount]="cartDetails?.donated_amount" [isOrderLoading]="isOrderLoading || vars.isOrderLoading"></app-donate-btn>
        <div class="divider"></div>
      </ng-container>
    </div>
  </div>

  <!-- upi-cashback section -->
  <div class="cashback-section" *ngIf="upiOffers?.length > 0 && vars.fundraiser?.cause?.parent_cause_id == 20 && vars.pageName === 'campaign'">
    <div class="cashback-strip" *ngFor="let offer of upiOffers">
      <img loading="lazy" *ngIf="offer?.image" [attr.data-src]="offer?.image" alt="upi_cashback" />
      <img loading="lazy" *ngIf="!offer?.image" src="/assets/images/payment/paytm_cashback.png" alt="upi_cashback" />
      <span class="title" [innerHTML]="offer?.title"></span>
    </div>
  </div>
  <!-- upi-cashback section -->

  <div *ngIf="!vars.disableUpi && option?.vpa_collect_enabled" class="or">
    <div class="or-line"></div>
    <span class="or-label">OR</span>
    <div class="or-line"></div>
  </div>

  <!-- VPA Payment form and button -->
  <app-upi-input *ngIf="vars.isAgent && option?.vpa_collect_enabled" [recommendedVpa]="recommendedVpa" [cartDetails]="cartDetails" [isOrderLoading]="isOrderLoading" [disableAll]="vars.upiTimer ? true : false" (onSubmit)="upiInputSubmit($event)"/>
  <form *ngIf="!vars.isAgent && option?.vpa_collect_enabled" [formGroup]="upiForm" class="upi-form" (ngSubmit)="submit()">
    <mat-form-field class="upi-input" [appearance]="isMobile?'standard':'fill'">
      <mat-label>Enter UPI Address (VPA)</mat-label>
      <input matInput formControlName="upiInput" placeholder="E.g. yourname@icici" [disabled]="vars.upiTimer" (focusout)="onVpaFocusOut()">
      <mat-error *ngIf="upiInput.hasError('pattern') && upiInput.touched">Invalid UPI ID</mat-error>
      <mat-error *ngIf="upiInput.hasError('required') && upiInput.touched">This field is required</mat-error>
    </mat-form-field>
    <app-donate-btn label="Contribute" [btnClass]="'submit-payment'" [amount]="cartDetails?.donated_amount" [disabled]="vars.upiTimer" [isOrderLoading]="isOrderLoading || vars.isOrderLoading">
    </app-donate-btn>
  </form>
  <div *ngIf="paymentUtil.utmProceedClicked">
    <app-utm-wallet-hundred type="payment" [donation]="cartDetails?.donated_amount"></app-utm-wallet-hundred>
  </div>
  <div *ngIf="vars.upiTimer" class="upi-process" [class.mt-2]="vars.isAgent">
    <span>Open your UPI app on your phone to approve the payment request from Ketto.</span>
    <span class="timer"> ({{countdown}})</span>
    <button class="cancel-btn" type="button" (click)="cancelPayment()" mat-button>Cancel Payment</button>
  </div>
</div>
